import React from 'react'
import PropTypes from 'prop-types'
import List from '@mui/icons-material/List'

const ListIcon = ({ height, width, ...more }) => {
	
	return (
		<List
			height={height}
			width={width}
			{...more}
		/>
	)
}

ListIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default ListIcon
